/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import { hash } from 'rsvp';
import { taskFor } from 'ember-concurrency-ts';
import type ReportingMetrics from 'embercom/services/reporting-metrics';

class AutomationFinAIAgentEcommerceAttributesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare reportingMetrics: ReportingMetrics;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.attributes',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel() {
    if (!this.appService.app.canUseFinFirstAiCategories) {
      return this.router.transitionTo('apps.app.automation.fin-ai-agent.ecommerce');
    }
    await taskFor(this.reportingMetrics.setup).perform();
    return hash({});
  }
}
export default ReactRoute(AutomationFinAIAgentEcommerceAttributesRoute);
